import { render, staticRenderFns } from "./add-teams-modal.vue?vue&type=template&id=4910cde8&scoped=true"
import script from "./add-teams-modal.vue?vue&type=script&lang=js"
export * from "./add-teams-modal.vue?vue&type=script&lang=js"
import style0 from "./add-teams-modal.vue?vue&type=style&index=0&id=4910cde8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4910cde8",
  null
  
)

export default component.exports